// extracted by mini-css-extract-plugin
module.exports = {"createAiAgentModalPage":"CreateEditAiAgentModal_createAiAgentModalPage___1b8G"};